<template>
  <section class="grid-section" :class="{'grid-section--inverted' : inverted}">
    <grid-figure
      class="grid-section__photo grid-section__photo--left"
      :key="columnData[0].img"
      :url="columnData[0].img"/>
    <div
      v-parallax-text
      class="grid-section__content grid-section__content--right">
      <h2 v-show-text
          class="grid-section__title">
        {{columnData[0].title}}
      </h2>
      <p v-show-text
         v-html="columnData[0].content">
      </p>
    </div>
  </section>
</template>

<script>
import GridFigure from '@/components/GridFigure.vue';

export default {
  name: 'GridSectionSingle',
  components: { GridFigure },
  props: {
    columnData: {
      type: Array,
      required: true,
    },
    inverted: {
      type: Boolean,
      default: false,
    },
  },
};
</script>


<style scoped lang="scss">
.grid-section {
  margin-top: 6vw;
  display: block;

  @include mq(ipadL) {
    display: grid;
    grid-template-columns: repeat(20, calc(65vw / 20));
    grid-template-rows: repeat(12, calc(65vw / 20));
  }

  @include mq(ds) {
    grid-template-rows: repeat(12, calc(65vw / 20));
  }


  &__photo {
    margin-bottom: 128px;
    padding: 0 20px;

    @include mq(ipadL) {
      margin-bottom: unset;
      padding: 0;
    }

    &--left {
      grid-area: 1 / 1 / 13 / 9;
    }

    &--right {
      grid-area: 18 / 14 / 28 / 21;

      @include mq(ipadL) {
        grid-area: 15 / 14 / 25 / 21;
      }

      @include mq(ds) {
        grid-area: 14 / 14 / 24 / 23;
      }
    }
  }

  &__title {
    margin-bottom: 50px;
    padding: 0 30px;
    text-align: center;
    text-transform: uppercase;

    align-self: end;

    @include mq(ipadL) {
      padding: 0;
      text-align: left;
      margin-bottom: unset;
    }

    @include mq(ds) {
      margin-bottom: 0.8rem;
    }
  }

  &__content {
    margin-bottom: 128px;
    text-align: center;

    @include mq(ipadL) {
      text-align: left;
      margin-bottom: unset;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &--left {
      grid-area: 17 / 2 / 24 / 11;

      @include mq(ds) {
        grid-area: 17 / 2 / 23 / 10;
      }
    }

    &--right {
      grid-area: 1 / 10 / 17 / 21;

      @include mq(ipadL) {
        grid-area: 1 / 12 / 12 / 21;
      }

      @include mq(ds) {
        grid-area: 2 / 12 / 9 / 20;
      }
    }
  }

  /*INVERTED*/
  &--inverted & {
    &__photo {
      &--left {
        grid-area: 1 / 1 / 11 / 8;
      }

      &--right {
        grid-area: 16 / 13 / 28 / 21;

        @include mq(ipadL) {
          grid-area: 13 / 13 / 25 / 21;
        }

        @include mq(ds) {
          grid-area: 12 / 13 / 24 / 21;
        }
      }
    }

    &__content {
      &--left {
        grid-area: 14 / 2 / 21 / 12;
        @include mq(ipadL) {
          grid-area: 14 / 1 / 24 / 10;
        }
      }

      &--right {
        grid-area: 1 / 9 / 15 / 20;
        @include mq(ipadL) {
          grid-area: 1 / 11 / 11 / 20;
        }
        @include mq(ds) {
          grid-area: 2 / 11 / 11 / 20;
        }
      }
    }
  }
}

.grid-section__content {
  & h2 {
   @include mq($from: ipadP, $until: ipadL) {
     font-size: 30px;
   }
  }

  & p {
   @include mq($from: ipadP, $until: ipadL) {
     font-size: 20px;
   }
  }
}
</style>
